/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Table, Button, Col, Row, Input } from 'antd';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import debounce from 'lodash/debounce';
import { Header, Title } from '$app/shared/components/Header';
import { Container } from '$app/shared/components/Container';
import Loading from '$app/shared/components/Loading';
import { getCampaigns } from './actions';
import { campaignVisibleForDeployment, segmentLabel } from '../../components/CampaignSegmentSelect';

function CampaignListPage(props) {
  const [dataSource, setDataSource] = useState([]);
  const [dataSourceOrigin, setDataSourceOrigin] = useState([]);

  useEffect(() => {
    async function fetchCampaigns() {
      const data = await getCampaigns();
      const campaigns = data.campaigns.filter((campaign) => campaignVisibleForDeployment(campaign.segment));
      setDataSource(campaigns);
      setDataSourceOrigin(campaigns);
    }
    try {
      fetchCampaigns();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('CampaignListPage error: ', err);
      throw err;
    }
  }, []);

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: '12%',
      sorter: (a, b) => a.name?.localeCompare(b.name),
    },
    {
      title: 'Market',
      dataIndex: 'segment',
      key: 'segment',
      width: '13%',
      sorter: (a, b) => (a.segment || '').localeCompare(b.segment || ''),
      render: (val) => segmentLabel(val),
    },
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
      width: '11%',
      sorter: (a, b) => a.code?.localeCompare(b.code),
    },
    {
      title: 'Start',
      dataIndex: 'validFromDate',
      key: 'validFromDate',
      width: '11%',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.validFromDate?.localeCompare(b.validFromDate),
      render: (val, record) => moment(record.validFromDate).format('YYYY-MM-DD HH:mm'),
    },
    {
      title: 'End',
      dataIndex: 'validUntilDate',
      key: 'validUntilDate',
      width: '11%',
      sorter: (a, b) => a.validUntilDate?.localeCompare(b.validUntilDate),
      render: (val, record) => moment(record.validUntilDate).format('YYYY-MM-DD HH:mm'),
    },
    {
      title: 'Single use',
      dataIndex: 'singleUse',
      key: 'singleUse',
      width: '8%',
      render: (val, record) => {
        if (record.singleUse) return 'True';
        return 'False';
      },
    },
    {
      title: 'Discount',
      dataIndex: ['discountAmountPence', 'discountAmountPercentage'],
      key: 'discount',
      width: '9%',
      render: (val, record) => {
        if (record.discountAmountPence) return <>£{record.discountAmountPence / 100}</>;
        return <>{record.discountAmountPercentage * 100}%</>;
      },
    },
    {
      title: 'To Checkout',
      dataIndex: 'appliedToCheckout',
      key: 'appliedToCheckout',
      width: '8%',
      render: (val, record) => {
        if (record.appliedToCheckout) return 'Applies';
        return 'Not Applies';
      },
    },
    {
      title: 'To EWO',
      dataIndex: 'appliedToEWO',
      key: 'appliedToEWO',
      width: '8%',
      render: (val, record) => {
        if (record.appliedToEWO) return 'Applies';
        return 'Not Applies';
      },
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      width: '9%',
      render: () => <Button type="link">Edit</Button>,
    },
  ];

  const activeSearch = debounce((value) => {
    if (!value.length) {
      setDataSource(dataSourceOrigin);
    } else {
      const filtered = dataSourceOrigin.filter((source) =>
        columns
          .map((c) => c.dataIndex)
          .reduce(
            (acc, fieldName) =>
              acc ||
              (source[fieldName] && source[fieldName].toLowerCase
                ? source[fieldName].toLowerCase().indexOf(value) >= 0
                : false),
            false
          )
      );
      setDataSource(filtered);
    }
  }, 200);

  const searchInputChange = (e) => {
    e.persist();
    const value = e.target.value.toLowerCase();
    activeSearch(value);
  };

  if (!dataSourceOrigin.length) return <Loading />;

  return (
    <Container>
      <Header>
        <Row justify="space-around" align="middle">
          <Col span={6}>
            <Title>Campaigns</Title>
            <Button
              type="link"
              className="create-btn"
              style={{ padding: 0, lineHeight: '10px' }}
              onClick={() => props.history.push('new')}
            >
              Create Campaign
            </Button>
          </Col>
          <Col span={18} style={{ textAlign: 'right' }}>
            <Input.Search
              placeholder="Search"
              onChange={searchInputChange}
              style={{ width: 200 }}
              defaultValue=""
            />
          </Col>
        </Row>
      </Header>
      <Table
        onRow={(record) => ({
          onClick: () => props.history.push(record.campaignId),
        })}
        size="small"
        rowKey={(record) => record.campaignId}
        pagination={{
          position: 'bottom',
          pageSize: 13,
        }}
        dataSource={dataSource}
        columns={columns}
      />
    </Container>
  );
}

export default withRouter(CampaignListPage);
